import {get} from '../request'

const mushroom = {
    /***
     * 获取夜野生菌百科 
     * @param ob
     */ 
    getMushroomList:(ob)=>{
        return get('/web/knowledgeEntity/getKnowledgeList',ob)
    },
    /***
     *  获取野生菌详细信息
     *  @param id 
     */ 
    getMushroomById:(id)=>{
        return get('/web/mushroomTypeEntity/getById?id='+id)
    },
    /***
     * 获取野生菌底部详细信息
     * @param id 
     */ 
    mushroomDetailInfoById:(id)=>{
        return get('/web/knowledgeEntity/getById?id='+id)
    }
}
export default mushroom


// WEBPACK FOOTER //
// ./src/api/modules/mushroom.js